import React from 'react'
import { NextPage, NextPageContext } from 'next'
import * as Sentry from '@sentry/nextjs'

import { STATUS_SERVER_ERROR } from '@scentregroup/shared/constants'
import ErrorComponent from '@scentregroup/shared/pages/error'
import {
  fetchNationalStaticData,
  NationalStaticData,
} from '@scentregroup/shared/hub-components/universal-header'
import { localeToCountry } from '@scentregroup/shared/helpers/local-to-country'
import { makeApolloClient } from '../lib/apolloClient'

interface Props {
  hasGetInitialPropsRun: boolean
  err: any
  headerStaticData: NationalStaticData
}

const sentryFlushMaxTime = 2000

const ErrorPage: NextPage<Props> = ({
  hasGetInitialPropsRun,
  err,
  headerStaticData,
}) => {
  if (!hasGetInitialPropsRun && err) {
    // see https://github.com/vercel/next.js/blob/canary/examples/with-sentry/pages/_error.js
    Sentry.captureException(err)
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return (
    <ErrorComponent
      headerStaticData={headerStaticData}
      status={STATUS_SERVER_ERROR}
    />
  )
}

// see https://github.com/vercel/next.js/blob/canary/examples/with-sentry/pages/_error.js
ErrorPage.getInitialProps = async ({
  err,
  asPath,
  locale,
}: NextPageContext) => {
  const client = makeApolloClient()

  const headerStaticData = await fetchNationalStaticData(client, {
    country: localeToCountry(locale),
  })

  const errorInitialProps = {
    hasGetInitialPropsRun: true,
    err,
    headerStaticData,
  }

  Sentry.captureException(
    err ||
      new Error(`_error.js getInitialProps missing data at path: ${asPath}`)
  )

  await Sentry.flush(sentryFlushMaxTime)

  return errorInitialProps
}

export default ErrorPage
